import { useNavigate } from 'react-router-dom';
import { Logo } from '@/components/layout/Logo';

const FEATURES: Array<[string, string]> = [
  ['Cardio', 'Runs, rides & swims — splits, pace, HR zones'],
  ['Strength', 'Log lifts, track tonnage & PRs'],
  ['Body', 'Weight, measurements & targets over time'],
  ['Health', 'Sleep, HRV, resting HR — daily readiness'],
];

/**
 * Mobile landing for signed-out users (≤768px). Rendered by {@link HomePage}
 * instead of the desktop hero. Brutalist handoff styling; CTAs route to the
 * existing login / register pages.
 */
export function MobileGuest() {
  const navigate = useNavigate();
  return (
    <div className="mhome">
      <div className="mh-px" style={{ paddingTop: 24 }}>
        <Logo height={30} />
        <h1 className="mh-h" style={{ fontSize: 'clamp(52px, 19vw, 76px)', marginTop: 26 }}>
          Train
          <br />
          harder.
          <br />
          <span className="mh-accent">Win more.</span>
        </h1>
        <p className="mh-tagline" style={{ marginTop: 16 }}>
          One cockpit for every session — cardio, strength, body and health. Log it, trust the trend
          line.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 24 }}>
          <button className="mh-btn" onClick={() => navigate('/login')}>
            Get started →
          </button>
          <button className="mh-btn mh-ghost" onClick={() => navigate('/register')}>
            Create account
          </button>
        </div>
      </div>

      <div className="mh-px mh-sec">
        <div className="mh-sectlab">
          <span>What you get</span>
          <em>free</em>
        </div>
        {FEATURES.map(([title, sub], i) => (
          <div className="mh-row" key={title} style={{ cursor: 'default' }}>
            <span className="mh-num-badge">{String(i + 1).padStart(2, '0')}</span>
            <span className="mh-main">
              <span className="mh-t">{title}</span>
              <span className="mh-s" style={{ textTransform: 'none' }}>
                {sub}
              </span>
            </span>
          </div>
        ))}
      </div>

      <div className="mh-px mh-sec">
        <p className="mh-tagline" style={{ textAlign: 'center' }}>
          Already a member?{' '}
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--accent)',
              font: 'inherit',
              cursor: 'pointer',
              fontWeight: 700,
            }}
          >
            Log in
          </button>
        </p>
      </div>
    </div>
  );
}
